import { useState } from "react"
import Modal from "../Modal"
import ProjectBoundryForm from "./ProjectBoundryForm"
import { ApolloError } from "@apollo/client"
import { BoundaryInputType, CRSType } from "../../types"
interface ProjectBoundryModalProps {
  closeModal: () => void
  onSubmit: () => void
  formData: any
  setFormData: React.Dispatch<React.SetStateAction<any>>
  initialFormData: any
  t: any
  geoCooedinatesError?: ApolloError
  geoCoordinatesLoading?: boolean
  active: CRSType
  boundaryInput: BoundaryInputType
  loading?: boolean
}

const EditProjectBoundaryModal = (props: ProjectBoundryModalProps) => {
  const { closeModal, onSubmit, formData, setFormData, t, initialFormData, active, boundaryInput } = props
  const [warning, setWarning] = useState({
    value: true,
    messssage: t("connectSettings.warningMessages.unChangedInput")
  })

  return (
    <Modal
      closeModal={closeModal}
      heading={t("connectSettings.modalHeading")}
      submitButtonText={t("connectSettings.submitButtonText")}
      submitButtonClasses="primary"
      onSubmitButtonClicked={onSubmit}
      submitSpinner={false}
      submitDisabled={warning.value}
      large={true}
    >
      <ProjectBoundryForm
        formData={formData}
        setFormData={setFormData}
        t={t}
        warning={warning}
        setWarning={setWarning}
        initialFormData={initialFormData}
        geoCooedinatesError={props.geoCooedinatesError}
        geoCoordinatesLoading={props.geoCoordinatesLoading}
        loading={props.loading}
        active={active}
        boundaryInput={boundaryInput}
      />
    </Modal>
  )
}

export default EditProjectBoundaryModal
